import { defaultClient } from './client';

const WL_URL = '/wl';
export const fetchConfig = ({ id }) => defaultClient.get(`${WL_URL}/configs/${id}`);
export const fetchConfigByIds = ({ ids }) =>
  defaultClient.get(`${WL_URL}/configs?${ids.map(id => `ids=${encodeURIComponent(id)}`).join('&')}`);

export const getWhitelabelUIConfig = subdomain => defaultClient.get(`${WL_URL}/${subdomain}.json`);
